import { useState } from 'react';

import { EducationModal, educationText } from '@/pages/hr/education/EducationEditor';
import { useEducations } from '@/pages/hr/education/educationApi';

/**
 * 내 학력 — 「내 정보」 표의 <b>칸 하나</b>(사용자 지시 2026-11-02). 최종학력과 학력을 나누지 않는다.
 *
 * <p>[수정] 을 누르면 <b>모달 하나</b>가 바로 뜨고 그 안에서 구분 · 학교 검색 · 공개 · 저장이 끝난다
 * (같은 날 지시: 「수정, 검색 뜨지 말고 모달 한 번에」). 표는 움직이지 않는다.
 */
export function MyEducationRow() {
  const view = useEducations(null);
  const [editing, setEditing] = useState(false);
  const text = educationText(view.data);

  return (
    <div>
      <dt>학력</dt>
      <dd className="truncate">
        {text || '-'}
        {view.data && text && (
          <span style={{ marginLeft: '6px', fontSize: '12px', fontWeight: 400, color: 'var(--text-muted)' }}>
            {view.data.open ? '공개' : '비공개'}
          </span>
        )}
      </dd>
      <span className="my-info-action">
        <button className="btn-secondary" style={{ fontSize: '12px', padding: '3px 10px' }} onClick={() => setEditing(true)}>
          수정
        </button>
      </span>
      {editing && <EducationModal personnelId={null} onClose={() => setEditing(false)} />}
    </div>
  );
}
